import {Button} from 'antd';
import React, {FC, useState} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {ITableReportProps} from 'components/table-report/table-report-types';

import {ControlRatiosStatisticTable} from '../tables/control-ratios-statistic-table';

interface IControlRatiosStatisticModalProps {
  buttonLabel: string;
  parentDocId: ITableReportProps['docId'];
  childDocId: ITableReportProps['docId'];
}

export const ControlRatiosStatisticModal: FC<IControlRatiosStatisticModalProps> = ({
    buttonLabel,
    parentDocId,
    childDocId,
}: IControlRatiosStatisticModalProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <ModalOpenerComponent
            isOpen={isModalOpen}
            setIsOpen={setIsModalOpen}
            handleCancel={handleCancel}
            handleSave={handleOk}
            hideControls={{all: true}}
            modalProps={{
                title: 'Статистика контрольных соотношений',
                forceRender: true,
                destroyOnClose: false,
                centered: true,
                width: '100%',
            }}
            component={(
                <Button type="link">
                    {buttonLabel}
                </Button>
            )}
        >
            {isModalOpen && (
                <ControlRatiosStatisticTable
                    parentDocId={parentDocId}
                    childDocId={childDocId}
                />
            )}
        </ModalOpenerComponent>
    );
};
